(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.CraftedHarmonyHeroParallax) {
      window.CraftedHarmonyHeroParallax.refresh();
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let heroes = [];
    let frameRequested = false;

    const update = () => {
      frameRequested = false;

      if (reducedMotion.matches) {
        heroes.forEach((hero) => hero.style.removeProperty('--hero-parallax-offset'));
        return;
      }

      const viewportHeight = window.innerHeight;

      heroes.forEach((hero) => {
        const rect = hero.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        const strength = Number.parseFloat(hero.dataset.parallaxStrength) || 0.2;
        const offset = (progress - 0.5) * rect.height * strength;
        hero.style.setProperty('--hero-parallax-offset', `${offset.toFixed(2)}px`);
      });
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    const refresh = () => {
      heroes = Array.from(document.querySelectorAll('[data-hero-parallax]'));
      requestUpdate();
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', refresh);
    reducedMotion.addEventListener('change', requestUpdate);

    window.CraftedHarmonyHeroParallax = { refresh };
    refresh();
  })();

  } catch(e) { console.error(e); }
})();
})();
